'use strict';

var empty = require('../../../_virtual/empty.js_commonjs-exports.js');
var PropTypes = require('prop-types');
require('./or.js');
require('./explicitNull.js');
require('./withShape.js');
require('./helpers/wrapValidator.js');
var explicitNull = require('../../../_virtual/explicitNull.js_commonjs-exports.js');
var withShape = require('../../../_virtual/withShape.js_commonjs-exports.js');
var wrapValidator = require('../../../_virtual/wrapValidator.js_commonjs-exports.js');
var or = require('../../../_virtual/or.js_commonjs-exports.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = PropTypes__default["default"];

var _or = _interopRequireDefault(or.__exports);

var _explicitNull = _interopRequireDefault(explicitNull.__exports);

var _withShape = _interopRequireDefault(withShape.__exports);

var _wrapValidator = _interopRequireDefault(wrapValidator.__exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var arrayOfValidator;
var validator = (0, _or["default"])([_explicitNull["default"], // null/undefined
(0, _propTypes.oneOf)([false, '', NaN]), (0, _withShape["default"])(_propTypes.array, {
  length: (0, _propTypes.oneOf)([0]).isRequired
}).isRequired, function () {
  return arrayOfValidator.apply(void 0, arguments);
}]);
arrayOfValidator = (0, _propTypes.arrayOf)(validator).isRequired;

var _default = function _default() {
  return (0, _wrapValidator["default"])(validator, 'empty');
};

exports["default"] = _default;

}(empty.__exports));
